var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iran",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.03,
    height: 32.03,
    viewBox: "0 0 32.03 32.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 16.015,
    cy: 15.756,
    rx: 16.015,
    ry: 15.756,
    transform: "translate(0)",
    fill: "#f0f0f0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M183.115,189.216h-2.13c.018.23.028.463.028.7a7.825,7.825,0,0,1-1.08,4.12,3.815,3.815,0,0,1-1.044,1.109v-5.925h-2.123v5.925a3.815,3.815,0,0,1-1.044-1.109,7.824,7.824,0,0,1-1.08-4.12c0-.234.01-.466.028-.7h-2.13c-.014.229-.021.461-.021.7,0,4.3,2.332,7.659,5.308,7.659s5.308-3.364,5.308-7.659C183.136,189.677,183.129,189.445,183.115,189.216Z",
    transform: "translate(-161.978 -177.379)",
    fill: "#d80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M30.51,7.659h2.123V9.052h2.123V7.659H36.88V9.052H39V7.659h2.123V9.052H43.25V7.659h2.123V9.052H47.5V7.659H49.62V9.052h5.108a16.4,16.4,0,0,0-29.326,0H30.51Z",
    transform: "translate(-24.215)",
    fill: "#6da544"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M49.62,367.3V368.7H47.5V367.3H45.373V368.7H43.25V367.3H41.127V368.7H39V367.3H36.88V368.7H34.757V367.3H32.634V368.7H30.51V367.3H25.4a16.4,16.4,0,0,0,29.326,0Z",
    transform: "translate(-24.215 -344.326)",
    fill: "#d80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIr);
export default __webpack_public_path__ + "static/media/IR.4bcdafd43e6c28251ff4be64e9b3cfdc.svg";
export { ForwardRef as ReactComponent };